import React from 'react';
import { ApaleoPropertyDto } from '../../../store/locationApaleoPropertySlice';
import translate from '../../translate';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-light-svg-icons';

interface Props {
    strings: {
        propertyId: string;
        name: string;
        postalCode: string;
        address: string;
        linkButton: string;
    };
    properties: ApaleoPropertyDto[];
    onLinkPropertyId: (propertyId: string) => void;
}

function LocationApaleoPropertyList(props: Props) {
    return (
        <table
            className={'data-table'}
            style={{ width: '100%' }}
            id={'locationApaleoPropertyTable'}
        >
            <thead>{renderHead()}</thead>
            <tbody>{props.properties.map(renderProperty)}</tbody>
        </table>
    );

    function renderHead() {
        return (
            <tr>
                <th>{props.strings.propertyId}</th>
                <th>{props.strings.name}</th>
                <th>{props.strings.postalCode}</th>
                <th>{props.strings.address}</th>
                <th></th>
            </tr>
        );
    }

    function renderProperty(property: ApaleoPropertyDto) {
        return (
            <tr>
                <td>{property.property_id}</td>
                <td>{property.name}</td>
                <td>{property.postal_code}</td>
                <td>{renderAddress()}</td>
                <td>{renderButton()}</td>
            </tr>
        );

        function renderAddress() {
            return (
                <div>
                    {property.address1}
                    {property.address1 && <br />}
                    {property.address2}
                    {property.address2 && <br />}
                    {property.address3}
                    {property.address3 && <br />}
                    {property.city}
                    <br />
                    {property.postal_code}
                </div>
            );
        }

        function renderButton() {
            return (
                <Button
                    onClick={handleClick}
                    className="btn btn-link btn-action mt-10"
                >
                    <FontAwesomeIcon
                        icon={faCheck}
                        className="icon-for-button"
                    />
                    {props.strings.linkButton}
                </Button>
            );
        }

        function handleClick() {
            props.onLinkPropertyId(property.property_id);
        }
    }
}

export default translate('LocationApaleoPropertyList')(
    LocationApaleoPropertyList
);
